import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDeviceModelsComplex } from '../../../service/graphql/machine/deviceModelsComplex';

import { AsyncThunkConfig } from '../../store';
import { selectCurrentAccount } from '../../User';
import { normalizeId } from '../utils';
import { IModel, TDeviceModelsComplexThunkPayload } from '../types';

export const deviceModelsComplexThunk = createAsyncThunk<IModel[], TDeviceModelsComplexThunkPayload, AsyncThunkConfig>(
  'addMachine/deviceModelsComplex',
  async (payload, { getState }) => {
    const { launchDarkly, addMachine } = getState();
    const country = selectCurrentAccount(getState()).userAccount?.account.country;
    const brandId = typeof payload === 'string' ? payload : payload.brandId;
    const rawCategoryId =
      typeof payload === 'string'
        ? addMachine.data.nonVinData?.category?.id
        : (payload.categoryId ?? addMachine.data.nonVinData?.category?.id);
    const rawSubCategoryId =
      typeof payload === 'string'
        ? addMachine.data.nonVinData?.subCategory?.id
        : (payload.subCategoryId ?? addMachine.data.nonVinData?.subCategory?.id);

    const categoryId = normalizeId(rawCategoryId);
    const subCategoryId = normalizeId(rawSubCategoryId);

    return getDeviceModelsComplex(launchDarkly.data, brandId, country, categoryId, subCategoryId);
  },
);
